import { render } from "./BreadcrumbsTeamsBlock.vue?vue&type=template&id=03c0babc&ts=true"
import script from "./BreadcrumbsTeamsBlock.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbsTeamsBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__